// src/ConsumerApp/utils/cartEvents.js

const resolveProductId = (item, explicitId) => {
  if (explicitId) return String(explicitId);
  return String(
    item?.product_id?._id ||
    item?.product_id ||
    item?.item_id?._id ||
    item?.item_id ||
    item?._id ||
    item?.id ||
    ''
  );
};

export const emitCartItemAdded = (item, newQuantity, explicitId) => {
  if (typeof window === 'undefined') return;
  const productId = resolveProductId(item, explicitId);
  window.dispatchEvent(
    new CustomEvent('cart-item-added', {
      detail: {
        item,
        productId,
        quantity: Math.max(1, Number(newQuantity) || 1),
        action: 'INCREMENT',
      },
    })
  );
};

export const emitCartItemUpdated = (item, newQuantity, explicitId) => {
  if (typeof window === 'undefined') return;
  const productId = resolveProductId(item, explicitId);
  const qty = Number(newQuantity) || 0;
  if (qty <= 0) {
    emitCartItemRemoved(productId);
    return;
  }
  window.dispatchEvent(
    new CustomEvent('cart-item-updated', {
      detail: {
        item,
        productId,
        quantity: qty,
        action: 'UPDATE',
      },
    })
  );
};

export const emitCartItemRemoved = (productId) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent('cart-item-removed', {
      detail: {
        productId: String(productId || ''),
        action: 'REMOVE',
      },
    })
  );
};